/* eslint-disable @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Input from '../../../../../components/input/Input';
import { GLOBAL_ICONS } from '../../../../../util/vars';
import Button from '../../../../../components/button/Button';
import { useMutation } from 'react-query';
import { model } from '@whizz/api-client';
import { useI18n } from '@whizz/react-i18n';
import { Alert, MaterialIcon } from '../../../../../components';
import { Section } from './Components';

export default function ChildLoginSection({ onSuccess, disabled }: Props) {
  const { translate } = useI18n();
  const [ showPassword, setShowPassword ] = useState(false);
  const [ error, setError ] = useState(null);
  const [ success, setSuccess ] = useState<string | null>(null);

  const {
    register,
    handleSubmit,
    formState: {
      isValid,
    },
  } = useForm({
    defaultValues: {
      username: '',
      password: '',
    },
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: ({ username, password }: { username: string; password: string }) => model.Identity.login({ username: username, password: password }),
    onSuccess: (identity) => {
      if ('student' === identity.user.type) {
        setSuccess(translate('pages.PARENT_EMAIL_PROCESS.CHILD_LOGIN.SUCCESS', { name: identity.user.name! }));
        setTimeout(() => onSuccess(identity.token!), 2400);
        return;
      }

      setError(translate('pages.PARENT_EMAIL_PROCESS.CHILD_LOGIN.ERRORS.TYPE'));
    },
    onError: (axiosResponse: any) => setError(axiosResponse.response.data.context.hint),
  });

  return (
    <>
      <Section index={1} disabled={disabled}>
        <div className={'space-y-2'}>
          <p>{translate('pages.PARENT_EMAIL_PROCESS.CHILD_LOGIN.line1')}</p>
          <p>{translate('pages.PARENT_EMAIL_PROCESS.CHILD_LOGIN.line2')}</p>
        </div>
        <form onSubmit={handleSubmit((values) => mutate({ username: values.username, password: values.password }))}>
          <div className={'mb-5'}>
            <Input
              {...register('username', { required: true })}
              id={'username'}
              label={translate('pages.PARENT_EMAIL_PROCESS.CHILD_LOGIN.FIELDS.username')}
              disabled={disabled}
              autoComplete={'username'}
            />
          </div>

          <div className={'mb-5'}>
            <Input
              {...register('password', { required: true, minLength: 5 })}
              id={'password'}
              label={translate('pages.PARENT_EMAIL_PROCESS.CHILD_LOGIN.FIELDS.password')}
              type={showPassword ? 'text' : 'password'}
              icon={GLOBAL_ICONS[showPassword ? 'see_off' : 'see_on']}
              onIconClick={() => setShowPassword(!showPassword)}
              disabled={disabled}
              autoComplete={'current-password'}
            />
          </div>

          {null !== error && (
            <Alert show type={'error'} className={'mb-5'}>
              {error}
            </Alert>
          )}

          <div className={'mb-5'}>
            {null !== success ? (
              <div className={'flex items-center gap-2'}>
                <MaterialIcon icon={GLOBAL_ICONS.tick} color={'positive'} />{success}
              </div>
            ) : (
              <Button
                isOutline
                isLoading={isLoading}
                color={'positive'}
                type={'submit'}
                onClick={() => setError(null)}
                disabled={disabled || isLoading || !isValid}
              >
                {translate('pages.PARENT_EMAIL_PROCESS.CHILD_LOGIN.FIELDS.submit')}
              </Button>
            )}
          </div>
        </form>
      </Section>
    </>
  );
}

interface Props {
  onSuccess: (token: string) => void;
  disabled: boolean;
}
